export const GET_GIFT_CARD_ELIGIBILITY = 'GET_GIFT_CARD_ELIGIBILITY';
export const GIFT_CARD_ELIGIBILITY_SUCCESS = 'GIFT_CARD_ELIGIBILITY_SUCCESS';
export const GIFT_CARD_REDEEM = 'GIFT_CARD_REDEEM';
export const GIFT_CARD_REDEEM_SUCCESS = 'GIFT_CARD_REDEEM_SUCCESS';
export const CLEAR_GIFT_CARD = 'CLEAR_GIFT_CARD';

export const GET_INCENTIVE_ELIGIBILITY = 'purchase/GET_INCENTIVE_ELIGIBILITY';
export const GET_INCENTIVE_INTRO_PRICE_PRODUCT = 'purchase/GET_INCENTIVE_INTRO_PRICE_PRODUCT';
export const INCENTIVE_ELIGIBILITY_SUCCESS = 'purchase/INCENTIVE_ELIGIBILITY_SUCCESS';
export const INCENTIVE_ELIGIBILITY_FAILURE = 'purchase/INCENTIVE_ELIGIBILITY_FAILURE';
export const CLEAR_ELIGIBILITY = 'purchase/CLEAR_ELIGIBILITY';
export const INCENTIVE_REDEEM = 'purchase/INCENTIVE_REDEEM';
export const INCENTIVE_REDEEM_SUCCESS = 'purchase/INCENTIVE_REDEEM_SUCCESS';
export const INCENTIVE_REDEEM_ERROR = 'purchase/INCENTIVE_REDEEM_ERROR';
export const INCENTIVE_IS_LOADING = 'purchase/INCENTIVE_IS_LOADING';
export const SET_INCENTIVE_PROMO_SOURCE = 'purchase/SET_INCENTIVE_PROMO_SOURCE';
export const INCENTIVE_INTRO_PRICE_PRODUCT_SUCCESS =
  'purchase/INCENTIVE_INTRO_PRICE_PRODUCT_SUCCESS';
export const INCENTIVE_INTRO_PRICE_PRODUCT_ERROR = 'purchase/INCENTIVE_INTRO_PRICE_PRODUCT_ERROR';
export const REDEEM_INCENTIVE_INTRO_PRICE_PRODUCT = 'purchase/REDEEM_INCENTIVE_INTRO_PRICE_PRODUCT';
export const INCENTIVE_INTRO_PRICE_REDEEM_SUCCESS = 'purchase/INCENTIVE_INTRO_PRICE_REDEEM_SUCCESS';
export const INCENTIVE_INTRO_PRICE_REDEEM_ERROR = 'purchase/INCENTIVE_INTRO_PRICE_REDEEM_ERROR';

export const GIFT_CARD_PROMO_SOURCE = 'bhn';
export const GIFT_CARD_CAMPAIGN_NAME = 'bhn_gift_card';
